<lib-nav-button-grid [navButtonList]="navButtonList"></lib-nav-button-grid>

